// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__zGhim","image":"Avatar_image____x52"};